var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","loading":_vm.downloadLoading,"icon":"el-icon-top-right","size":"small"},on:{"click":_vm.exportExcel}},[_vm._v("导出")])
}
var staticRenderFns = []

export { render, staticRenderFns }